export default {
  keyword: 'Keyword',
  location: 'Location',
  search: 'Search',
  jobs: 'Jobs',
  searchJobs: 'Search Jobs',
  postAJob: 'POST A JOB',
  exploreCompanies: 'Explore Companies',
  companies: 'Companies',
  createCompany: 'CREATE COMPANY',
  browseTalent: 'Browse Talent',
  talent: 'Talent',
  joinTalentPool: 'JOIN TALENT POOL',
  loadMore: 'Load More',
  negotiable: 'Negotiable',
  contract: 'Contract',
  permanent: 'Permanent',
  remote: 'Remote',
  percentOfSalary: '% of salary',
  rewardInCrypto: 'Reward in Crypto',
  rewardInUSD: 'Reward in USD',
  applyOrRefer: 'Apply or refer somebody to this job to earn rewards in BTC, STX or VIBES',
  freeDonation: 'Free Donation',
  everySuccessfulHire: 'Every successful hire creates a donation for charity, free from HireVibes',
  viewJobsAndCompany: 'View jobs and company info',
  salaryMin: 'Salary (min)',
  undisclosed: 'Undisclosed',
  noticePeriod: 'Notice Period',
  available: 'Available',
  permanentAndContract: 'Permanent/Contract',
  engineering: 'Engineering',
  allJobs: 'All Jobs',
  allEmploymentTypes: 'All Job Types',
  allSalaries: 'All Salaries',
  optIn: 'Opt-in to be considered for other jobs in this company’s network',
  firstName: 'First Name',
  lastName: 'Last Name',
  attachCv: 'Attach CV',
  apply: 'Apply',
  referSome: 'Refer Somebody',
  applicants: 'APPLICANTS',
  openJobs: 'OPEN JOBS',
  noJobs: 'NO JOBS',
  thereNoJobs: 'There\'s no jobs',
  thisJobsJob: 'This Jobs Board is powered by HireVibes.\n' +
    'To post a job, you’ll be directed to app.hirevibes.com\n',
  thisJobsCompany: 'This Jobs Board is powered by HireVibes.\n' +
    'To create your company, you’ll be directed to app.hirevibes.com\n',
  thisJobsTalent: 'This Jobs Board is powered by HireVibes.\n' +
    'To join this talent pool, you’ll be directed to app.hirevibes.com\n'

}



// WEBPACK FOOTER //
// ./src/i18n/en/widget.js